import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";
import logo from "../images/logo.jpg";

function Header() {
  const [logoSize, setLogoSize] = useState("170px");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setLogoSize("120px");
      } else {
        setLogoSize("170px");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo-link">
          <img
            src={logo}
            alt="Logo"
            className="logo-icon"
            style={{ width: logoSize, height: "auto" }}
          />
        </Link>
        <div className="header-buttons">
          <Link to="/download" className="button-item1">
            資料請求
          </Link>
          <Link to="/inquiry" className="button-item2">
            お問い合わせ
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
